




























import Vue from "vue";
import axios from "axios";
export default Vue.extend({
  name: "SearchPlot",
  props: {
    map: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    inputValue: "",
    error: null,
    isULDKoading: false,
    uldkError: false,
    plotsList: [],
  }),
  computed: {},

  methods: {
    checkInputType($event: any) {

      this.uldkError = false; 
      this.error = null;      

      if ($event.key === "Enter") {
        this.loaduldk(this.inputValue);
      }
    },
    submit() {
      this.loaduldk(this.inputValue);
    },

    async loaduldk(plotNo) {
      if (plotNo) {
        this.isULDKoading = true;

        const urlUldk =
          "https://uldk.gugik.gov.pl/?request=GetParcelByIdOrNr&id=";

        try {
          const res = await axios.get(
            urlUldk +
              plotNo +
              "&result=teryt,county,commune,voivodeship,geom_wkt"
          );

          // 141201_1.0001.1867/2
          // Kolonia 253

          if (res.data.substring(0, 1) == "1") {
            // success
            this.plotsList = [];
            this.isULDKoading = false;
            this.drawPlot(res.data);
          } else if (Number(res.data.substring(0, 1)) > 1) {
            // success, więcej niż 1 wynik
            this.plotsList = res.data.split(/\r?\n/).slice(1, -1); 
            this.isULDKoading = false;
          } else if (res.data.substring(0, 2) == "-1") {
            // error
            this.plotsList = []
            this.isULDKoading = false;
            this.uldkError = true;
          }
        } catch (err) {
          this.isULDKoading = false;
          this.error = err;
        }
      }
    },
    drawPlot(polygon) {      
      this.$emit("plotLoaded", polygon);
    },
    selectPlot(id){
      this.drawPlot(id+1);
      this.plotsList = []
    },    
  },
});
